import React from "react";
import { TailSpin } from "react-loader-spinner";
import styled from "styled-components";

import variableColors from "../../_App.module.scss";

const { primaryColor } = variableColors;

const Div = styled.div<{ $height: string }>`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100%;
  height: ${(props) => props.$height};
`;

const TailSpinner = ({ height }: { height: string }): JSX.Element => {
  // console.log({ height });
  return (
    <React.Fragment>
      <Div $height={height}>
        <TailSpin
          height="120"
          width="120"
          color={primaryColor}
          ariaLabel="tail-spin-loading"
          radius="3"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </Div>
    </React.Fragment>
  );
};

export default TailSpinner;
